import React, { useState } from 'react';
import { Link } from "react-router-dom";
import { useSelector } from 'react-redux';
import toast from 'react-hot-toast';
import { Checkbox, Form, Input, Select } from 'antd';
import LoadableButton from "../../../../../components/buttons/LoadableButton.jsx";
import { CreateUPSWithdrawRequestApi } from '../../../../../api/request/wallet/withdraw.js';

const accountTypeOptions = [
    { label: 'UPI', value: 1 },
    { label: 'RTGS/ IMPS/ NEFT', value: 2 },
];

const UPSWithdraw = ({ amount, resetAll }) => {
    const [form] = Form.useForm();
    const { userDetails } = useSelector(state => state.user);
    const [isLoading, setIsLoading] = useState(false);
    const [accountType, setAccountType] = useState(1);

    const handleSubmit = async (values) => {
        setIsLoading(true);
        try {
            const params = {
                userId: userDetails?._id,
                amount: Number(amount),
                withdrawalMethod: 10,
                accountType,
                fullName: values?.fullName || '',
                upiId: accountType === 1 ? values?.upiId : '',
                bankName: accountType === 2 ? values?.bankName : '',
                bankAccountNumber: accountType === 2 ? values?.bankAccountNumber : '',
                ifscCode: accountType === 2 ? values?.ifscCode : '',
            };

            const { data } = await CreateUPSWithdrawRequestApi(params);
            if (data?.success) {
                toast.success(data?.message);
                form?.resetFields();
                setAccountType(1);
                resetAll();
            } else if (data?.error?.message) {
                toast.error(data?.error?.message);
            }
        } catch (error) {
            if (error?.response?.data?.error?.message)
                toast.error(error?.response?.data?.error?.message);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className='h-full'>
            <Form
                form={form}
                layout="vertical"
                className='space-y-5 flex flex-col justify-between h-full'
                onFinish={handleSubmit}
                initialValues={{ accountType: 1 }}
            >
                <div className="space-y-5">
                    <Form.Item
                        name="accountType"
                        label={<span className="text-lg text-gray-500 font-medium">Select Payment Method</span>}
                        rules={[{ required: true, message: 'Please select a payment method.' }]}
                    >
                        <Select
                            placeholder="Select Payment Method"
                            size="large"
                            options={accountTypeOptions}
                            onChange={(value) => setAccountType(value)}
                        />
                    </Form.Item>

                    {accountType === 1 ? (
                        <div className="grid md:grid-cols-2 gap-5">
                            <Form.Item
                                name="fullName"
                                label={<span className="text-lg text-gray-500 font-medium">Full Name</span>}
                                rules={[{ required: true, message: 'Please enter full name.' }]}
                            >
                                <Input placeholder="Full Name" size="large" />
                            </Form.Item>
                            <Form.Item
                                name="upiId"
                                label={<span className="text-lg text-gray-500 font-medium">UPI ID</span>}
                                rules={[{ required: true, message: 'Please enter UPI ID.' }]}
                            >
                                <Input placeholder="UPI ID" size="large" />
                            </Form.Item>
                        </div>
                    ) : (
                        <div className="grid md:grid-cols-2 gap-5">
                            <Form.Item
                                name="fullName"
                                label={<span className="text-lg text-gray-500 font-medium">Account Holder Name</span>}
                                rules={[{ required: true, message: 'Please enter account holder name.' }]}
                            >
                                <Input placeholder="Account Holder Name" size="large" />
                            </Form.Item>
                            <Form.Item
                                name="bankName"
                                label={<span className="text-lg text-gray-500 font-medium">Bank Name</span>}
                                rules={[{ required: true, message: 'Please enter bank name.' }]}
                            >
                                <Input placeholder="Bank Name" size="large" />
                            </Form.Item>
                            <Form.Item
                                name="bankAccountNumber"
                                label={<span className="text-lg text-gray-500 font-medium">Bank Account Number</span>}
                                rules={[{ required: true, message: 'Please enter bank account number.' }]}
                            >
                                <Input placeholder="Bank Account Number" size="large" />
                            </Form.Item>
                            <Form.Item
                                name="ifscCode"
                                label={<span className="text-lg text-gray-500 font-medium">IFSC Code</span>}
                                rules={[{ required: true, message: 'Please enter IFSC code.' }]}
                            >
                                <Input placeholder="IFSC Code" size="large" />
                            </Form.Item>
                        </div>
                    )}
                </div>

                <div className="space-y-5">
                    <Form.Item
                        name="conditions"
                        valuePropName="checked"
                        rules={[{ validator: (_, value) => value ? Promise.resolve() : Promise.reject(new Error('Please accept the terms and conditions.')) }]}
                    >
                        <Checkbox className='mt-4'>
                            Yes, I agreed to the <Link to={'/terms_&_conditions'} className='primary hover:underline duration-300'>Terms and conditions</Link>
                        </Checkbox>
                    </Form.Item>

                    <LoadableButton
                        className='bg-primary text-sm text-white font-semibold rounded-lg px-12 py-2 uppercase themeHover duration-500'
                        type="submit"
                        lable='Submit'
                        isLoading={isLoading}
                        loadingLable='Adding request...'
                    />
                </div>
            </Form>
        </div>
    );
};

export default UPSWithdraw;
